module.exports = __webpack_public_path__ + "img/single-brand.28b5b34f.png";